import { BaseService } from './BaseService';
import { DashboardViewModel, VeterinaryDashboardViewModel } from '../models/dashboard';

export class DashboardService extends BaseService {
  /**
   * `farmId` picks the source, the same way `GET /dashboard/piglets` does: omitted, the token's own
   * business unit; set, another farm, which the API allows admins only. That is what lets the admin read a
   * farm opened from the farms overview without re-issuing the token onto it.
   */
  getDashboard = async (farmId?: string): Promise<DashboardViewModel> => {
    // BuildQueryString drops the empty parameter rather than sending `farmId=`, which the API would read
    // as a farm named badly rather than as no farm at all.
    const query = this.BuildQueryString({ farmId });
    const result = await this.Fetch(`/dashboard?${query}`, 'GET');

    return this.FromResult<DashboardViewModel>(result);
  };

  getVeterinaryDashboard = async (): Promise<VeterinaryDashboardViewModel> => {
    const result = await this.Fetch('/vets/dashboard', 'GET');

    return this.FromResult<VeterinaryDashboardViewModel>(result);
  };
}

export default DashboardService;
